/**
 * Les Parisiennes — Collection Module
 */
(function () {
  'use strict';
  var LP = window.LPTheme || {};

  function registerInit(name, fn) {
    if (LP && typeof LP.registerInit === 'function') LP.registerInit(name, fn);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
   * 6. FILTER DRAWER
   * ============================================================ */
  window.toggleFilterDrawer = function () {
    var drawer = document.getElementById('filter-drawer');
    var overlay = document.getElementById('filter-overlay');
    if (!drawer) return;
    var isOpen = drawer.classList.contains('is-open');
    drawer.classList.toggle('is-open');
    if (overlay) overlay.classList.toggle('is-open');
    document.body.style.overflow = isOpen ? '' : 'hidden';
  };

  window.toggleFilterGroup = function (el) {
    var group = el.closest ? el.closest('.filter-group') : el;
    if (!group) {
      group = el;
    }
    group.classList.toggle('is-open');
  };

  /* Filter form submission */
  function initFilterForm() {
    var form = document.getElementById('filter-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var params = new URLSearchParams();
      var sortBy = formData.get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);
      for (var pair of formData.entries()) {
        if (pair[0] === 'sort_by') continue;
        /* Skip empty price filter values so they don't zero-out results */
        var val = pair[1];
        if (val === '' || val === null || val === undefined) continue;
        if ((pair[0].indexOf('price') !== -1 || pair[0].indexOf('.gte') !== -1 || pair[0].indexOf('.lte') !== -1) && (val === '0' || Number(val) === 0)) continue;
        params.append(pair[0], val);
      }
      var baseUrl = window.location.pathname;
      var qs = params.toString();
      window.location.href = qs ? (baseUrl + '?' + qs) : baseUrl;
    });
  }

  function initCollectionLoadMore() {
    var wrap = document.querySelector('[data-load-more-wrap]');
    var grid = document.querySelector('[data-product-grid]');
    if (!wrap || !grid || wrap.dataset.loadMoreReady === 'true') return;
    wrap.dataset.loadMoreReady = 'true';

    var btn = wrap.querySelector('[data-load-more]');
    var status = wrap.querySelector('[data-load-more-status]');
    var pagination = document.querySelector('[data-pagination]');
    var current = parseInt(wrap.dataset.currentPage || '1', 10);
    var total = parseInt(wrap.dataset.totalPages || '1', 10);
    var loadingLabel = 'Loading...';
    var buttonLabel = btn ? btn.textContent.trim() : 'Load more';
    var remainingTemplate = wrap.dataset.remainingTemplate || '__COUNT__ pages left';
    var completeText = wrap.dataset.completeText || 'All products loaded';

    function updateStatus() {
      if (!status) return;
      var remaining = Math.max(total - current, 0);
      status.textContent = remaining > 0 ? remainingTemplate.replace('__COUNT__', String(remaining)) : completeText;
    }

    function appendCardsFrom(html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var nextGrid = temp.querySelector('[data-product-grid]');
      if (!nextGrid) return false;
      nextGrid.querySelectorAll('.product-card').forEach(function (card) {
        card.classList.add('is-revealed');
        grid.appendChild(card);
      });
      var nextWrap = temp.querySelector('[data-load-more-wrap]');
      current = nextWrap ? parseInt(nextWrap.dataset.currentPage || String(current + 1), 10) : current + 1;
      total = nextWrap ? parseInt(nextWrap.dataset.totalPages || String(total), 10) : total;
      if (nextWrap && nextWrap.dataset.nextUrl) {
        wrap.dataset.nextUrl = nextWrap.dataset.nextUrl;
        if (btn) btn.hidden = false;
      } else {
        delete wrap.dataset.nextUrl;
        if (btn) btn.hidden = true;
      }
      var freshPagination = temp.querySelector('[data-pagination]');
      if (pagination && freshPagination) pagination.innerHTML = freshPagination.innerHTML;
      updateStatus();
      return true;
    }

    updateStatus();
    if (!btn) return;
    btn.addEventListener('click', function () {
      var nextUrl = wrap.dataset.nextUrl;
      if (!nextUrl || btn.disabled) return;
      btn.disabled = true;
      btn.textContent = loadingLabel;
      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          if (html) appendCardsFrom(html);
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = buttonLabel;
          if (!wrap.dataset.nextUrl) btn.hidden = true;
        });
    });
  }

  registerInit('initFilterForm', initFilterForm);
  registerInit('initCollectionLoadMore', initCollectionLoadMore);
}());
